// accordionData.js
export const accordionData = {
  general: [
    {
      header: "Rize: Enhanced",
      body: (
        <div>
          <p>
            <strong>1. What are the new features on Rize?</strong>
            <br />
            You’ll experience a smoother, simpler Rize with a new logo,
            pre-login screen, and onboarding from 15 November 2024 onwards.
          </p>
          <p>
            <strong>2. How do I tell if the new Rize logo is authentic?</strong>
            <br />
            Compare it against what’s on this website and follow our social
            media accounts (Facebook, Instagram, LinkedIn, and TikTok) for
            updates.
          </p>
          <p>
            <strong>
              3. What other recent improvements have been made on the Rize app?
            </strong>
            <br />
            We now have a pre-login screen from which you can explore the app
            features instantly, without having to log in. We also simplified the
            onboarding journey to expedite sign-ups and activation of new
            accounts.
          </p>
          <p>
            <strong>4. Can I still check my Financial Insights?</strong>
            <br />
            We’ll be removing this feature with Rize: Enhanced. We’re working on
            more updates that you’re going to love!
          </p>
          <p>
            <strong>5. When will Rize: Enhanced come into effect?</strong>
            <br />
            The Rize app will be updated on 15 November 2024. You can download
            it from the Apple AppStore, Google Playstore, and Huawei AppGallery.
          </p>
          <p>
            <strong>
              6. I’m an existing Rize app user. How do I get the new features?
            </strong>
            <br />
            The app will prompt you to update when you open it for the first
            time.
          </p>
          <p>
            <strong>7. Can my phone get the new features?</strong>
            <br />
            Here’s the minimum Operating System (OS) your phone will need to be
            on:
            <ul style={{ margin: "0" }}>
              <li>iOS 15 and above</li>
              <li>Android 11 and above</li>
              <li>Huawei HarmonyOS version 3 (EMUI 13)</li>
            </ul>
            Your digital experience is our priority. That’s why we regularly
            update the app to match the latest OS versions. Remember to stay on
            top of OS updates to ensure the app works seamlessly for you.
          </p>
          <p>
            <strong>
              8. If you’re having trouble logging in, try the following:
            </strong>
            <ul style={{ margin: "0" }}>
              <li>
                Check for app updates: Make sure you have the latest version of
                the Rize app from the Apple AppStore, Google Playstore, or
                Huawei AppGallery.
              </li>
              <li>
                Relaunch the app: Once updated, restart the app and try logging
                in again.
              </li>
            </ul>
          </p>
          <p>
            <strong>
              9. Who can I contact if I have questions about Rize?
            </strong>
            <br />
            Contact our Customer Support team at{" "}
            <a href="tel:1800819149">1 800 819 149</a> (Local toll-free) or{" "}
            <a href="tel:+60162996610">+6016 299 6610</a> (Local & Overseas).
            Alternatively, email to our Customer Support at{" "}
            <a
              href="mailto:rize-cs@alrajhibank.com.my"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              rize-cs@alrajhibank.com.my
            </a>
            .
          </p>
        </div>
      ),
      // parseHtml: true,
    },

    {
      header: "What is Rize?",
      body: "Rize is alrajhi bank Malaysia’s new digital bank, which offers easier banking services and financial products directly through your smartphone.",
    },
    {
      header:
        "What is the difference between Rize and alrajhi bank Malaysia’s smartphone banking app (alrajhi@24seven)?",
      body: "Rize is a new digital bank and is separate from any account you may already own and have access to through alrajhi@24seven. Rize will bring you a new digital banking experience and exciting digital financial products and services entirely via your smartphone with no visit to the branch.",
    },
    {
      header: "How can I open a Rize account? ",
      body: "Download the Rize app from Apple Store, Google Play or Huawei AppGallery. You will need a valid MyKad (sorry, MyTentera cardholders are not currently eligible, but we&#39;re working on it!). Simply follow the on-screen instructions to open an account.",
    },
    {
      header: "Can I open a Rize account in any alrajhi bank Malaysia branch?",
      body: "A Rize account can only be opened through the Rize app, which is available at Apple Store, Google Play Store and Huawei AppGallery. Rize customer support and branch employees are always available for any inquiry.",
    },
    {
      header: "What happens after I submit my account opening application? ",
      body: "Our automated system will review your application and notify you once it is approved. Once approved, you can then proceed to activate your account by transferring a minimum of RM20 via DuitNow Transfer from your own account with another registered bank into your new Rize account. Interbank GIRO transactions will not be accepted.",
    },
    {
      header:
        " Do I need to walk into a branch for physical verification after my application?",
      body: "No, you do not need to walk into any branch. All verification and approvals are done via the smartphone application. Our customer support is on hand should you need help.",
    },
    {
      header:
        "Can I re-apply or onboard again if my application was not successful on the first application? ",
      body: "Yes, you may reapply. Kindly ensure &nbsp;you meet the eligibility criteria in the General Terms of Use.",
    },
    {
      header:
        "What is the minimum smartphone operating software version required to use Rize?",
      body: (
        <div>
          <p>
            The minimal software requirements to install the Rize app are as
            follows:
          </p>
          <ul>
            <li>iOS 15 and above.</li>
            <li>Android 11 and above.</li>
            <li>Huawei Harmony OS version 3 (EMUI 13) and above.</li>
          </ul>
        </div>
      ),
    },
    {
      header: "Can I open an account with Rize if I am not Malaysian?",
      body: "Currently, Rize is only open to Malaysian citizens with a blue MyKad. We are continuously working towards expanding the availability to everyone across Malaysia. You will hear from us as we grow.",
    },
    {
      header:
        "I do not have an existing bank account in my name in Malaysia. Can I open a Rize account?",
      body: (
        <p>
          You are required to have at least 1 (ONE) bank account in your name at
          another registered bank in Malaysia (we accept alrajhi bank Malaysia
          account) as part of the account opening verification process.<br></br>
          <br></br>A minimum initial deposit of RM20 from that account will need
          to be transferred into Rize for account activation.
        </p>
      ),
    },
    {
      header: " What can I do with the Rize app? ",
      body: (
        <div>
          <p>
            Rize will serve your banking needs with a wide range of financial
            services such as:
          </p>

          <ul>
            <li>
              Deposits, withdrawals, and transfers (via DuitNow or QR Pay)
            </li>
            <li>
              Account management and personal finance management (spend
              analysis)
            </li>
            <li>Savings pots (to customize and support your savings needs)</li>
            <li>Debit card application, purchases, and maintenance</li>
            <li>ATM services and eStatements</li>
          </ul>

          <p>Many more exciting features and products are coming your way.</p>
        </div>
      ),
    },
    {
      header: "Can I access Rize when travelling overseas?",
      body: "Yes, all you need is the smartphone device on which you have installed the Rize app, and an internet connection via Wi-Fi or cellular data roaming &nbsp;to access the Rize app.",
    },
    {
      header: "Can I open an account with Rize if I am not a Malaysian?",
      body: "Currently, Rize is only open to Malaysian citizens with a blue MyKad. Malaysians with a MyTentera card are not eligible for now. We are continuously working towards expanding the availability to everyone across Malaysia. You will hear from us as we grow.",
    },
    {
      header:
        "I’m an existing alrajhi bank Malaysia customer. Can I open a Rize account?",
      body: "Yes, Rize is open to all Malaysians with a blue MyKad, even if you are holding an alrajhi bank Malaysia account.",
    },
    {
      header: "What are the requirements for opening a Rize account?",
      body: (
        <div>
          {" "}
          <ul type="disc">
            <li>
              Malaysian citizen with a valid MyKad. We&rsquo;re sorry, MyTentera
              cardholders are not eligible for now.
            </li>
            <li>18 years of age and above.</li>
            <li>
              Applicant must be a tax resident in Malaysia (Malaysian taxpayer
              and not of another country).
            </li>
            <li>Hold an active bank account with another bank in Malaysia.</li>
          </ul>
        </div>
      ),
    },
  ],
  accounts: [
    {
      header:
        "What should I do if I do not receive a one-time password (OTP) via SMS?",
      body: (
        <div>
          <ul>
            <li>
              You should receive your OTP at the point of onboarding while
              registering your device (we do not use OTP for account opening or
              transaction verification)&nbsp;
            </li>
            <li>
              Please ensure your smartphone number is entered correctly during
              the registration process
            </li>
            <li>
              Please contact your telco provider and report the delay in
              receiving the OTP.
            </li>
          </ul>
        </div>
      ),
    },
    {
      header: "Can I open more than one Rize account?",
      body: "You can only open one Rize account linked to your MyKad identification.",
    },
    {
      header: "Are the deposits in my Rize account protected?",
      body: (
        <div>
          <p>
            Yes, your deposit with Rize Savings Account-i is protected by up to
            RM250,000.00 by Perbadanan Insurans Deposit Malaysia (PIDM).
          </p>
        </div>
      ),
    },
    {
      header: "Can I close my Rize account?",
      body: (
        <div>
          <p>
            You may close your Rize account by contacting Rize Customer Support.
            Contact details are on the Rize app.
          </p>
        </div>
      ),
    },
    {
      header:
        "Can a third party (spouse/family member) assist to close my Rize account?",
      body: (
        <div>
          <p>
            A spouse or family member may only assist in specific circumstances.
            For account closure due to death/being in a coma/dementia (or the
            like), it is a requirement for the customer’s next of
            kin/executor/administrator to submit an official account closure
            application to Rize Customer Support via the email address
            rize-cs@alrajhibank.com.my. Once we receive the official
            application, we will email detailed instructions and a list of
            supporting documents that the next of kin/executor/administrator is
            required to provide to the Bank. All account activities will be
            suspended when the official request is received from the next of
            kin/executor/administrator.
          </p>
        </div>
      ),
    },
    {
      header: "Can I open a joint account in Rize?",
      body: (
        <div>
          <p>
            Currently, only individual accounts are offered through the Rize
            app.
          </p>
        </div>
      ),
    },
  ],
  funds: [
    {
      header: "What is DuitNow? Are there any fees for using DuitNow?",
      body: (
        <div>
          <ul>
            <li>
              DuitNow is a convenient way to transfer money instantly to your
              recipients using DuitNow ID, including your smartphone number,
              MyKad/passport number, army/police number, business registration
              or account number.
            </li>
            <li>
              No, it is FREE for consumers to send and receive money up to
              RM5,000. For transactions above RM5,000, a RM0.50 sen fee is
              applicable.
            </li>
          </ul>
        </div>
      ),
    },
    {
      header: "Are there any limits for fund transfers performed on Rize?",
      body: (
        <div>
          <ul>
            <li>
              The maximum combined limit set for third party transfer, DuitNow
              (Instant Transfer), and DuitNow QR is RM50,000.00 per day.
            </li>
            <li>
              You may change the limit set under ‘Account Settings & Limits’
              section in the Rize App.
            </li>
          </ul>
        </div>
      ),
    },
    {
      header: "Does Rize accept Interbank GIRO transactions?",
      body: (
        <div>
          <p>
            No. Any Interbank GIRO transaction made into your Rize account will
            be rejected and refunded into the source account.
          </p>
        </div>
      ),
    },
    {
      header: "What payment types are available on Rize?",
      body: (
        <div>
          <ul type="disc">
            <li>DuitNow Transfer (1st and 3rd parties)</li>
            <li>DuitNow QR (1st and 3rd parties)</li>
          </ul>
        </div>
      ),
    },
  ],
  savings: [
    {
      header: "What is Savings Pot? How many savings pots can I open?",
      body: (
        <div>
          <p>
            Savings Pot is a goal savings feature in the Rize app. You may
            create up to 10 savings pots to achieve your savings goals.
          </p>
        </div>
      ),
    },
    {
      header:
        "How can I add/withdraw money from a savings pot? How frequently can I do it?",
      body: (
        <div>
          <p>
            You can transfer money from your savings account to your savings pot
            and you may withdraw any amount from your savings pot at any time.
          </p>
        </div>
      ),
    },
    {
      header: "Do I get a profit for the funds in my savings pot?",
      body: (
        <div>
          <ul>
            <li>
              Yes, profit rate is applicable for savings/deposits in a savings
              pot.
            </li>
            <li>
              Please refer to Rize Savings Account Product Disclosure Sheet for
              the latest applicable profit rate (%).
            </li>
          </ul>
        </div>
      ),
    },
    {
      header:
        "What will happen to the money in my savings pot if my Rize account is inactive?",
      body: (
        <div>
          <p>
            Your money will remain in the savings pot for seven (7) years. If
            your account is still inactive after seven (7) years, your money
            will be treated/transferred as unclaimed monies under the Unclaimed
            Money Act (UMA) 1965.
          </p>
        </div>
      ),
    },
    {
      header: "Are there any records/history/statements of my savings pot?",
      body: (
        <div>
          <p>
            Yes, your savings pot transaction history will appear in the
            combined statement under Personal Statement. You will receive
            automated eStatements monthly from your Rize app.
          </p>
        </div>
      ),
    },
  ],
  security: [
    {
      header: "How secure is the Rize app?",
      body: (
        <div>
          <ul>
            <li>
              Rize security is setup using the latest cloud-based technology
              with biometric authentication.
            </li>
            <li>
              Your access is protected by a strict authentication process with
              only one session allowed per user at a time.
            </li>
            <li>Only single-device binding is allowed for each user.</li>
          </ul>
        </div>
      ),
    },
    {
      header: "What is biometric authentication?",
      body: (
        <div>
          <p>
            Rize uses biometric authentication (face recognition or fingerprint
            as selected by you) every time you login to the app. You may also
            use device pin verification for access.
          </p>
        </div>
      ),
    },
    {
      header: "What should I do if I forget my password?",
      body: (
        <div>
          <p>Please follow the steps below to reset your password:</p>
          <ol>
            <li>On the login screen, tap on the “Forgot Password” option.</li>
            <li>You will be asked to confirm your “Secure Word”.</li>
            <li>Then, enter your NRIC.</li>
            <li>
              After that, a temporary password will be sent to your registered
              email address.
            </li>
            <li>
              Now, log in to the app again and confirm your “Secure Word”.
            </li>
            <li>
              You will then be prompted to enter the temporary password emailed
              to you.
            </li>
            <li>
              Finally, create a new password, and you will see a confirmation
              message on the screen once it’s completed.
            </li>
          </ol>
        </div>
      ),
    },
    {
      header: "How can I access Rize if I switch to a new smartphone?",
      body: (
        <div>
          <p>
            If you change your smartphone, simply download the Rize app on your
            new phone and login using your existing username and password. You
            will be asked to authenticate and authorize to bind the new device.
            The previous tagging to your old device will be removed
            automatically. You will not be able to access your Rize account from
            your old device.
          </p>
        </div>
      ),
    },
    {
      header: "What if my smartphone is stolen or lost?",
      body: (
        <div>
          <ul>
            <li>
              The Rize app cannot be accessed by other individuals without your
              user ID and passcode and/or biometric authentication. For security
              purposes, do not store any account details or password in your
              device.
            </li>
            <li>
              Contact our Rize Customer Support at 1800 819 149 or email us at
              rize-cs@alrajhibank.com.my to temporarily block access to the Rize
              account.
            </li>
            <li>
              Once you have your new smartphone, simply call us to unblock the
              access and download the Rize app to your new phone. You may login
              using your existing username and password.
            </li>
            <li>You are advised to change your password.</li>
          </ul>
        </div>
      ),
    },
    {
      header: "What should I do if I switch telco providers?",
      body: (
        <div>
          <ul>
            <li>
              If you retain your existing smartphone number with the new telco
              provider, you do not need to do anything.
            </li>
            <li>
              If you change your smartphone number with the new telco provider,
              please log in to the Rize app on the same device and update your
              smartphone number in the Profile page.
            </li>
          </ul>
        </div>
      ),
    },
    {
      header:
        "What can I do to avoid becoming a victim of scams and losing my Rize savings?",
      body: (
        <div>
          <ul>
            <li>
              Take extra precaution with login details. Do not share login
              information, including your OTP, with anyone; set a strong
              password containing a combination of uppercase and lowercase
              letters, numbers, and special characters.
            </li>
            <li>
              Be mindful of the apps you are downloading on to your phone. Only
              download and install apps from official app stores, i.e., Apple
              AppStore, Google Play Store or Huawei AppGallery, to avoid
              malware/viruses.
            </li>
            <li>
              Keep your smartphone up to date. Having the latest security
              software and operating system is the best defenses against
              viruses, malware, and other online threats. Turn on automatic
              updates so you receive the newest fixes as they become available.
            </li>
            <li>
              Beware of phishing and smishing scams. Do not click on links or
              open any attachments or pop-up screens from sources that you are
              not familiar with in email, WhatsApp messages, or SMS.
            </li>
            <li>
              Do not share your personal information online. Be wary of requests
              to connect from people you do not know.
            </li>
            <li>
              Secure your internet connection. Always protect your home wireless
              network with a password. Avoid using public Wi-Fi for your banking
              needs.
            </li>
            <li>
              When in doubt, call Rize Customer Support via the Rize app
              ‘Contact Us’ feature.
            </li>
          </ul>
        </div>
      ),
    },
    {
      header:
        "What should I do if I get a call from someone saying they are calling me regarding a transaction issue with my Rize account?",
      body: (
        <div>
          <ul>
            <li>
              If the caller is asking for your password or OTP, do not continue
              with the call. We will never ask for these details.
            </li>
            <li>
              When in doubt, always end the call and call Rize Customer Support
              via the app ‘Contact Us’ feature.
            </li>
          </ul>
        </div>
      ),
    },
    {
      header: "Can’t access Rize? Here’s what you need to know.",
      body: (
        <>
          If you can’t access Rize, your phone may be a rooted/jailbroken
          device. For security reasons, the Rize app is incompatible with
          devices that are rooted or jailbroken. This is because your device
          will be exposed to malware that can gain administrative or privileged
          access to your phone’s operating system (OS). Unsupported OS receive
          fewer or no security patches, resulting in your system being
          vulnerable to viruses, malware, and other security threats.
        </>
      ),
    },
  ],
  pf: [
    {
      header: "Is there Takaful coverage for Personal Financing-𝘪?",
      body: (
        <div>
          <p>
            Not at present. We are considering Takaful Coverage as an optional
            add-on product soon.
          </p>
        </div>
      ),
    },
    {
      header:
        "What if I fail to fulfill my obligations under Personal Financing-𝘪?",
      body: (
        <div>
          <p>
            You may incur charges if you fail to fulfill your obligations under
            the Personal Financing<i>-i</i>. Please refer to our product
            disclosure sheet in the Rize smartphone app or contact Rize Customer
            Support via the app ‘Contact Us’ feature.
          </p>
        </div>
      ),
    },
    {
      header: "How do I pay my monthly instalments?",
      body: (
        <div>
          <p>
            You may pay your monthly instalments through the Rize app. The
            monthly payment will be auto debited from your savings account.
          </p>
          <p>
            Should your savings account have insufficient monies, you will
            receive a notification in the app asking for a top-up of funds or
            for a partial payment to be made. We would encourage you to contact
            Rize customer support if you are facing challenges or difficulties.
          </p>
        </div>
      ),
    },
    {
      header: "Where can I get assistance and redress?",
      body: (
        <div>
          <p>
            If you have difficulties in making monthly payments, you should
            contact us earliest possible to discuss payment alternatives.
          </p>
          <strong>Rize Customer Support</strong>
          <p>Level 6, Menara Hap Seng 3,</p>
          <p>No 1, Jalan P. Ramlee,</p>
          <p>50250 Kuala Lumpur</p>
          <p>
            Telephone: Customer Support: 1800 81 9149 (Within Malaysia) /
            +6016-299 6610 (From Abroad) 24hrs Fraud Support: +6016–299 5333
            (Within Malaysia & From Abroad)
          </p>
          <p>
            Email:{" "}
            <strong>
              <u>Rize-cs@alrajhibank.com.my</u>
            </strong>
          </p>
          <p>
            Alternatively, you may seek the services of Agensi Kaunseling dan
            Pengurusan Kedit (AKPK), an agency established by Bank Negara
            Malaysia to provide free services on money management, credit
            counselling, financial education and debt restructuring for
            individuals.
          </p>
          <p>
            You are also encouraged to attend the “Program Pengurusan Wang
            Ringgit Anda” or “POWER” organized by AKPK which promotes prudent
            money management and financial discipline to individual borrowers.
            You can visit website at{" "}
            <u>
              <strong>www.akpk.org.my</strong>
            </u>{" "}
            or contact AKPK at:
          </p>
          <p>Level 5 and 6, Menara Bumiputra Commerce,</p>
          <p>Jalan Raja Laut,</p>
          <p>50350 Kuala Lumpur</p>
          <p>Tel: 03-2616 7766</p>
          <p>
            e-mail:{" "}
            <u>
              <strong>enquiry@akpk.org.my</strong>
            </u>
          </p>
        </div>
      ),
    },
  ],
  contact: [
    {
      header:
        " Is there a Customer Support Line? What are the operating hours?",
      body: (
        <div>
          <p>You may reach our 24-hour hotline at:</p>

          <p>Customer Support Line (Local toll-free)</p>

          <p>
            <strong>1800 81 9149</strong>
          </p>

          <p>Customer Support Line (Local &amp; overseas)</p>

          <p>
            <strong>+6016 299 6610</strong>
          </p>

          <p>&nbsp;</p>

          <p>Fraud Hotline (Local &amp; overseas)</p>

          <p>
            <strong>+6016 299 5333</strong>
          </p>

          <p>
            Email: <strong>rize-fraud@alrajhibank.com.my</strong>
          </p>

          <p>&nbsp;</p>

          <p>Customer Support Email</p>

          <p>
            <strong>rize-cs@alrajhibank.com.my</strong>
          </p>

          <p>&nbsp;</p>

          <p>Our Support team operates 24 hours, 7 days a week.</p>
        </div>
      ),
    },
  ],
  killswitch: [
    {
      header: "What is the Rize Kill Switch?",
      body: (
        <div>
          <p>
            This self-service security feature allows our customers to instantly
            lock their Rize app or account access, if they:
          </p>
          <ul>
            <li>
              Suspect or have fallen victim to any online fraud or scams, and/or
            </li>
            <li>Suspect their accounts have been compromised.</li>
          </ul>
          <p>
            Once this feature is enabled, neither the customer nor anyone else
            can access or log in to their Rize app or account.
          </p>
        </div>
      ),
    },
    {
      header:
        "What are the benefits of the Kill Switch? Or When should I use the Kill Switch?",
      body: (
        <div>
          <p>
            The Kill Switch should be used if you suspect you have fallen victim
            to online fraud or scams or think your account has been compromised.
          </p>
          <p>The Kill Switch feature will:</p>
          <ul>
            <li>Log out all active sessions of the Rize app</li>
            <li>Block or prevent any unauthorized transactions</li>
            <li>Block any further login attempts</li>
          </ul>
        </div>
      ),
    },
    {
      header: "How do I activate the Kill Switch?",
      body: (
        <div>
          <p>To activate the Kill Switch from your Rize mobile app:</p>
          <p>
            <strong>Step 1:</strong> Launch the Rize mobile application
          </p>
          <p>
            <strong>Step 2:</strong> Go to Settings &amp; Service
          </p>
          <p>
            <strong>Step 3:</strong> Click on Account &amp; Card settings
          </p>
          <p>
            <strong>Step 4:</strong> Toggle and activate Kill Switch
          </p>
          <p>
            <strong>Step 5:</strong> Click on the 'confirm' button
          </p>
          <p>
            You and all other active login sessions will be logged out
            automatically, and no one, including yourself, will be able to
            access your Rize mobile app.
          </p>
          <p>
            To reactivate your access, contact our Rize Customer Support at 1800
            819 149 (Local toll-free) and +6016 299 6610 (Local &amp; overseas)
            for assistance. All customers will be required to complete a strict
            identity verification process to proceed with the User ID
            reactivation.
          </p>
        </div>
      ),
    },
    {
      header: "How will I know if my Kill Switch has been activated?",
      body: (
        <div>
          <p>
            Once the Kill Switch has been activated, a 'Rize access has been
            deactivated' notice will appear when you attempt to open the app.
          </p>
        </div>
      ),
    },
    {
      header: "I have activated my Kill Switch. What happens now?",
      body: (
        <div>
          <p>
            All logins to the Rize app and accounts will be disabled once the
            Kill Switch has been activated.
          </p>
          <p>
            Contact our 24/7 Fraud Hotline at +6016 299 5333 (Local &amp;
            overseas) immediately to report your account’s suspected scam/fraud.
          </p>
        </div>
      ),
    },
    {
      header: "How do I reactivate my Rize access?",
      body: (
        <div>
          <p>
            Call our 24/7 Rize Customer Support line at 1800 819 149 (Local
            toll-free) and +6016 299 6610 (Local &amp; Overseas) to reactivate
            your Rize access.
          </p>
          <p>
            Customers must complete a strict identity verification process to
            reactivate the User ID.
          </p>
        </div>
      ),
    },
    {
      header: "How long before I can login to Rize app after reactivation?",
      body: (
        <div>
          <p>
            Once our customer support team completes the identity verification
            process successfully, customers may access their Rize app
            immediately and perform any transaction as usual.
          </p>
        </div>
      ),
    },
    {
      header:
        "If I activated the Kill Switch and have existing standing instructions or financing repayment, will the funds still be transferred on the effective date?",
      body: (
        <div>
          <p>
            Yes, all scheduled or existing standing instructions or financing
            repayments will still be executed on the effective date even when
            the Kill Switch is activated.
          </p>
        </div>
      ),
    },
    {
      header:
        "Can I still use my Rize debit card if I have activated the Kill Switch?",
      body: (
        <div>
          <p>
            Yes, you can still use your Rize debit card for withdrawals,
            physical purchases, or online transactions.
          </p>
        </div>
      ),
    },
    {
      header:
        "If I need to temporarily block my Rize debit card, do I need to activate the Kill Switch?",
      body: (
        <div>
          <p>
            No, to temporarily block your Rize debit card from any transactions
            you may log in to the app and activate 'Temporary freeze card'.
          </p>
        </div>
      ),
    },
    {
      header:
        "Can I still use my DuitNow QR for payment transactions if I have activated the Kill Switch?",
      body: (
        <div>
          <p>
            No. You cannot make any payments on the Rize app once the Kill
            Switch is activated.
          </p>
          <p>
            Call our 24/7 Rize Customer Support line at 1800 819 149 (Local
            toll-free) and +6016 299 6610 (Local &amp; overseas) to reactivate
            your Rize access.
          </p>
        </div>
      ),
    },
    {
      header:
        "Can I still receive any incoming transfers to my account made via DuitNow or DuitNow QR?",
      body: (
        <div>
          <p>
            Yes, you can still receive incoming transfers made to your account.
            Your contacts can continue to transfer funds to you using your
            DuitNow details.
          </p>
        </div>
      ),
    },
  ],
  coolingoff: [
    {
      header: "What is a Cooling Off Period?",
      body: (
        <div>
          <p>
            A cooling-off period is an added security measure which prevents
            anyone from logging into your Rize account for a temporary time. The
            12-hour cooling-off period is aimed at preventing unauthorized
            access and transactions.
          </p>
          <p>
            After installing the Rize app or switching to a new device,
            customers must wait for a 12-hour cooling-off period before
            performing or approving any banking transactions. The 12-hour period
            begins upon completion of the first-time login.
          </p>
          <p>
            This security measure is to prevent any unauthorized access to your
            Rize account and replaces the existing call verification process.
          </p>
        </div>
      ),
    },
    {
      header: "What happens during Cooling Off period (12 hrs)?",
      body: (
        <div>
          <p>
            During the 12-hour cooling off period, the following will either be
            inaccessible or disabled:
          </p>
          <ul>
            <li>ATM cash withdrawals with Rize debit card</li>
            <li>ATM fund transfers with Rize debit card</li>
            <li>Fund transfers (DuitNow to accounts/proxy/QR)</li>
            <li>
              Transfers within own account (e.g., Savings Pots, Financing
              Accounts)
            </li>
            <li>
              All recurring charges and standing instructions using Rize account
              or Rize debit card
            </li>
            <li>All financing payments</li>
            <li>
              All Visa and MyDebit transactions using ATMs or Rize debit card -
              physical or digital transactions.
            </li>
          </ul>
        </div>
      ),
    },
    {
      header:
        "When does the 12-hour Cooling Off period begin and when would I know it has ended?",
      body: (
        <div>
          <p>The 12-hour cooling off period will start upon:</p>
          <ul>
            <li>
              The successful transaction of RM20 fund transfer to activate your
              new Rize account.
            </li>
            <li>
              After your new/switched device has successfully bound with the app
              and its passcode settings are complete.
            </li>
          </ul>
          <p>
            You will also receive a Push notification on your Rize app once the
            cooling off period has ended.
          </p>
        </div>
      ),
    },
    {
      header:
        "I need to access my account urgently during the Cooling Off period, what can I do?",
      body: (
        <div>
          <p>
            Contact our 24/7 Customer Support Line at 1800 819 149 (Local
            toll-free) or +6016 299 6610 (Local & overseas) for assistance.
          </p>
        </div>
      ),
    },
  ],
  notices: [
    {
      header: "Temporary Service Disruption – December 2024",
      body: (
        <div>
          <p>27 November 2024</p>
          <p>
            Dear customer,
            <br />
            <br />
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at the following times:
          </p>
          <ul type="disc">
            <li>
              1 December 2024 (Sunday) from 00.00 AM until 3:00 AM (3 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
            <li>
              14 December 2024 (Saturday) 00.30 AM until 6:30 AM (6 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
          </ul>
          <p>
            We apologize for any inconvenience this may cause. Don’t worry,
            we’ll be back soon!
            <br />
            <br />
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149 (Local toll-free) or +6016 299 6610 (Local &
            overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Rize Update",
      body: (
        <div>
          <p>25 October 2024</p>
          <p>
            Dear customer,<br></br>
            Please be informed that the Financial Insights feature will be
            unavailable from the next app update. We’re sorry for the
            inconvenience, but we’re working on several exciting updates to this
            and other features for you in the coming days. We’ll keep you
            posted.
          </p>
          <p>
            Al Rajhi Banking & Investment Corporation (Malaysia) Bhd
            Registration Number 200501036909 (719057-X)
          </p>
        </div>
      ),
    },
    {
      header: "Notice on Interbank GIRO (IBG)",
      body: (
        <div>
          <p>23 October 2024</p>
          <p>
            Dear customer,<br></br>
            Please be informed that Rize only accepts DuitNow Transfer or
            DuitNow QR for incoming transfers. Interbank GIRO transfers will not
            be accepted.
          </p>
          <p>
            Al Rajhi Banking & Investment Corporation (Malaysia) Bhd
            Registration Number 200501036909 (719057-X)
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption – November 2024",
      body: (
        <div>
          <p>22 October 2024</p>
          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at the following times:
          </p>

          <ul type="disc">
            <li>
              1 November 2024 (Friday) from 00.00 AM until 3:00 AM (3 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
            <li>
              9 November 2024 (Saturday) 00.30 AM until 4:30 AM (4 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
            <li>
              16 November 2024 (Saturday) 00.30 AM until 4:30 AM (4 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
            <li>
              23 November 2024 (Saturday) 00.30 AM until 4:30 AM (4 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
          </ul>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: " Temporary Service Disruption – October 2024 ",
      body: (
        <div>
          <p>24 September 2024</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at the following times:
          </p>

          <ul type="disc">
            <li>
              1 October 2024 (Tuesday) from 00.00 AM until 3:00 AM (3 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
            <li>
              3 October 2024 (Thursday) from 01.00AM until 3:00 AM (2 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
            <li>
              15 October 2024 (Tuesday) from 01.30 AM until 8:00 AM (6 hours and
              30 minutes) - Incoming &amp; outgoing transactions will not be
              available.
            </li>
            <li>
              19 October 2024 (Saturday) from 01.00 AM until 6:00 AM (5 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
            <li>
              26 October 2024 (Saturday) from 00.30 AM until 4:30 AM (4 hours) -
              Incoming &amp; outgoing transactions will not be available.
            </li>
          </ul>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Revision to the Rize Personal Financing-i Application Document",
      body: (
        <div>
          <p>20 September 2024</p>

          <p>Dear Rize Personal Financing-i Customers,</p>

          <p>
            Please be informed that the Rize Personal Financing-i Application
            Document in the app, under &ldquo;Important Documents&rdquo;, has
            been revised. The revisions only apply to customers who currently
            have a Rize Personal Financing-i account.
          </p>

          <p>The changes made to the document are as follows:</p>

          <ol>
            <li>
              The &ldquo;3 days grace period&rdquo; has been removed as it is no
              longer applicable.
            </li>
            <li>
              This revision will come into effect on&nbsp;<b>12 October 2024</b>
              . Please click
              <a href=" https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/personal.pdf">
                <font color="blue">here</font>
              </a>
              for the latest Personal Financing-i Product Disclosure Sheet.
            </li>
          </ol>

          <p>Al Rajhi Banking &amp; Investment Corporation (Malaysia) Bhd</p>

          <p>Registration Number 200501036909 (719057-X)</p>
        </div>
      ),
    },
    {
      header:
        "New Fraud Measures for Rize: Cooling Off Period for Increased Transaction Limits and DuitNow QR Activation",
      body: (
        <div>
          <p>
            Dear Rizers,
            <br />
            &nbsp;
            <br />
            Effective from 11 th July 2024, a 12-hour cooling off period will be
            in effect when customers activate&nbsp;DuitNow QR for the first
            time, and when customers request an increase in transaction limits
            for any of the following channels:
          </p>

          <ul>
            <li>DuitNow to Proxy&nbsp;</li>
            <li>Within Bank Account&nbsp;&nbsp;</li>
            <li>DuitNow to Account&nbsp;</li>
            <li>DuitNow QR Limit&nbsp;&nbsp;&nbsp;</li>
          </ul>

          <p>
            The cooling-off period is a 12-hour waiting period from the
            submission of a new application or request.&nbsp;This period will
            apply to all other channels as listed above.
          </p>

          <p>
            <strong>
              <u>Here are some FAQs to address any concerns:</u>
            </strong>
          </p>

          <ol>
            <li>
              <strong>
                Why do we need this 12-hour cooling-off period?&nbsp;
              </strong>
              <br />
              The additional cooling-off period aims to prevent unauthorized
              transactions following the increase in transaction limits and the
              activation of DuitNow QR.
              <br />
              &nbsp;
            </li>
            <li>
              <strong>
                Will the 12-hour cooling-off period apply to all transaction
                channels after increasing&nbsp;the limit for just one
                transaction type?&nbsp;
              </strong>
              <br />
              No. For example, if you choose to increase the transaction limit
              for the activation of DuitNow QR, the 12-hour cooling-off period
              would only apply to transactions using that channel. You&nbsp;will
              still be able to complete other transactions using other available
              channels.
              <br />
              &nbsp;
            </li>
            <li>
              <strong>
                Will the 12-hour cooling-off period be applied if I choose to
                lower the transaction limit?&nbsp;
              </strong>
              <br />
              No, the 12-hour cooling-off period only applies to requests to
              increase transaction limits.
              <br />
              &nbsp;
            </li>
            <li>
              <strong>
                While the 12-hour cooling-off period is in effect for a certain
                transaction channel, what&nbsp;would happen if I either increase
                the transaction limit again or reduce its limit?&nbsp;
                <br />
                -&nbsp;
              </strong>
              If you increase the transaction limit again for that transaction
              channel, the cooling-off&nbsp;period will restart.&nbsp;
              <br />
              - Reducing the limit after increasing it beforehand will not
              remove the current 12-hour&nbsp;cooling-off period. Hence, the
              cooling-off period will remain for that transaction&nbsp;channel
              until the 12 hours have elapsed.
              <br />
              &nbsp;
            </li>
            <li>
              <strong>What happens after I activate DuitNow QR?&nbsp;</strong>
              <br />
              The 12-hour cooling-off period will come into effect, and you will
              only be able to perform&nbsp;DuitNow QR transactions after the 12
              hours have elapsed.
            </li>
          </ol>

          <p>&nbsp;</p>

          <p>
            If you have any queries, please call our 24/7 Customer Support team
            on 1 800 819 149 (Local toll-&nbsp;free) or +6016 299 6610 (Local
            &amp; overseas) or email us at rize-cs@alrajhibank.com.my.
          </p>

          <p>
            Thank you for your cooperation in ensuring a secure online banking
            experience.
          </p>

          <p>
            From,&nbsp;
            <br />
            The Rize team
          </p>
        </div>
      ),
    },
    {
      header: "Update your mobile device OS for seamless Rize access",
      body: (
        <div>
          <p>
            Published date: 1 March 2024
            <br />
            <br />
            Dear Rizers,
          </p>

          <p>
            We&rsquo;re continually updating our security measures for Rize. To
            keep your mobile banking experience safe and secure, the Rize app
            will only support mobile phones&nbsp;operating on iOS 15 and above,
            Android 11 and above, or Huawei Harmony OS version 3 (EMUI 13) and
            above effective 1 June 2024.
          </p>

          <p>
            To avoid any service interruption, please ensure your device is
            updated to the latest operating system. No action is required if
            your device is already running on the latest OS.
          </p>

          <p>
            <br />
            <u>
              <b>Here are some FAQs to address any concerns:</b>
            </u>
            <br />
            <br />
            1.&nbsp;&nbsp;&nbsp;&nbsp;
            <b>Why is there a minimum phone OS requirement?</b>
          </p>

          <p>
            Outdated operating systems may no longer receive security updates,
            leaving your device vulnerable to cyber-attacks and malware.
            With&nbsp;evolving cyber security threats,&nbsp;regular updates are
            more important than ever.
          </p>

          <p>
            2.&nbsp;&nbsp;&nbsp;&nbsp;<b>Which OS do I need?</b>
          </p>

          <p>
            From 1 June 2024, iOS users should be on iOS 15 and above, Android
            users on Android 11 and above, and Huawei users on Huawei Harmony OS
            version 3 (EMUI 13) and above.
            <br />
            <br />
            3.&nbsp;&nbsp;&nbsp;&nbsp;
            <b>How do I check or update my phone OS?</b>
          </p>

          <p>
            Navigate to &lsquo;Settings&rsquo; on your mobile device and select
            &lsquo;About Device&rsquo;. You should find an option to update your
            OS version.
            <br />
            <br />
            4.&nbsp;&nbsp;&nbsp;&nbsp;
            <b>What if I&rsquo;m unable to update my phone OS?</b>
          </p>

          <p>
            You may need to check if your mobile device is compatible with the
            required OS version. If not, consider upgrading to a device that
            supports the necessary OS version.
          </p>

          <p>
            <br />
            For further assistance or inquiries, please reach out to our 24/7
            Customer Support team at 1800 819 149 (Local toll-free) or +6016 299
            6610 (Local &amp; overseas), or email us at
            rize-cs@alrajhibank.com.my.
          </p>

          <p>
            Thank you for your cooperation in ensuring a secure mobile banking
            experience.
          </p>

          <p>
            Thank you,
            <br />
            Rize
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption – 30 Apr 2024 (Updated) ",
      body: (
        <div>
          <p>Published date: 30 April 2024 (Updated)</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at&nbsp;the following times:-
          </p>

          <p>&nbsp;</p>

          <p>
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/30_apr_2024_notice.png"
            />
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption – 23 Apr 2024 ",
      body: (
        <div>
          <p>Published date: 23 April 2024</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at&nbsp;the following times:
          </p>

          <p>&nbsp;</p>

          <p>
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/23_april_2024_notice.png"
            />
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption – 25 Mar 2024",
      body: (
        <div>
          <p>Published date: 25 March 2024</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at&nbsp;the following times:
          </p>

          <p>&nbsp;</p>

          <p>
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/TemporaryServiceDisruption%E2%80%9325Mar2024.png"
            />
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption – 26 Feb 2024",
      body: (
        <div>
          <p>Published date: 26 February 2024</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at&nbsp;the following times:
          </p>

          <p>&nbsp;</p>

          <p>
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/26_2_2024_notice.png"
            />
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption – 31 Jan 2024 (Updated)",
      body: (
        <div>
          <p>Published date: 31 January 2024</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at&nbsp;the following times:
          </p>

          <p>&nbsp;</p>

          <p>
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/31_Jan_2024_updated.png"
            />
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: " Temporary Service Disruption – 22 Jan 2024 ",
      body: (
        <div>
          <p>Published date: 22 January 2024</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at&nbsp;the following times:
          </p>

          <p>&nbsp;</p>

          <p>
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/22-Jan-2024-notice.png"
            />
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption – 9 Jan 2024",
      body: (
        <div>
          <p>Published date: 9 January 2024</p>

          <p>Hi&nbsp;Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance at&nbsp;the following times:
          </p>

          <p>&nbsp;</p>

          <p>
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/timeschedule_9_jan_2024.png"
            />
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for any inconvenience this may cause. Don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or&nbsp; +6016 299 6610
            (Local &amp; overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption - 1 Jan 2024",
      body: (
        <div>
          <p>Published date: 28 December 2023</p>

          <p>Hi Rizers,</p>

          <p>
            Please be informed that the Rize app will be temporarily unavailable
            due to necessary system maintenance on&nbsp;
            <b>Monday, 1 January 2024 from 12.00 am to 6.00 am</b>. We apologize
            for any inconvenience this may cause, but don&rsquo;t worry,
            we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or +6016 299 6610&nbsp;(Local
            &amp; Overseas).
          </p>
        </div>
      ),
    },
    {
      header: "Electrify Your Dreams 2023 Campaign Notice",
      body: (
        <div>
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/electrify_notice.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: " Rize Do Less, Get More Campaign Notice",
      body: (
        <div>
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/rize_do_less_get_more_campaign_notice.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "DuitNow Service Maintenance",
      body: (
        <div>
          <p>
            Hi Rizers,
            <br />
            <br />
            Kindly be informed that DuitNow Transfer will be temporarily
            unavailable during a scheduled maintenance on:
            <br />
            <br />
            <br />
            <img
              alt="Service downtime.png"
              className="img-fluid"
              src="https://www.rize.com.my/application/themes/RizeTheme/assets/img/rfp_servicedowntime.png"
            />
            <br />
            <br />
            <br />
            We apologize if this has caused any inconvenience to you. Please
            contact our Customer Care at 1800 81 9149 if you need any assistance
            or have any questions. We are ready to serve you anytime, anywhere!
          </p>
        </div>
      ),
    },
    {
      header: "10% off Liga Malaysia 2023 tickets",
      body: (
        <div>
          <p>
            Great news! You can still enjoy 10% off Liga Super 2023 tickets when
            you use your Rize debit card to purchase tickets via Ticket
            Hotline!&nbsp;
            <br />
            <br />
            The discount will be automatically rebated to your account.
            <br />
            &nbsp;
          </p>

          <p>
            Not on Rize?&nbsp;
            <br />
            <br />
            <a
              href="https://www.rize.com.my/easierwithrize.html"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download Now!</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "General Maintenance",
      body: (
        <div>
          <p>Hi Rizers,</p>

          <p>
            Kindly be informed that the following services will be temporarily
            unavailable due to schedule system maintenance:
            <br />
            &nbsp;
          </p>

          <p>
            <img
              alt="confirmed.png"
              className="img-fluid"
              src="https://www.rize.com.my/index.php/download_file/view_inline/421c49de-9e57-41a4-946b-ba4fbfca7baf"
            />
          </p>

          <p>
            <br />
            We apologize if this has caused any inconvenience to you. Please
            contact our Customer Care at 1800 81 9149 if you need any assistance
            or have any questions. We are ready to serve you anytime, anywhere!
          </p>
        </div>
      ),
    },
    {
      header: "Rize Planned Maintenance - 8 May 2023",
      body: (
        <div>
          <p>Hi Rizers,</p>

          <p>
            Please be informed that the following services will be temporarily
            unavailable due to scheduled system maintenance:
          </p>

          <p>
            <u>
              <strong>Maintenance Details:</strong>
            </u>
          </p>

          <p>
            <strong>Date:&nbsp; 8th May 2023 (Monday)</strong>
          </p>

          <p>
            <strong>
              Time:&nbsp;&nbsp;11.00 p.m. &ndash; 12.00 a.m. (1 hour)
            </strong>
          </p>

          <p>
            <strong>
              Remarks:&nbsp;&nbsp;The Rize app will be unavailable during this
              period&nbsp;as we are upgrading our database.
            </strong>
          </p>

          <p>&nbsp;</p>

          <p>
            We apologize for causing inconvenience to you. Please contact our{" "}
            <strong>Customer Care</strong>
            <b>
              <i> </i>
            </b>
            at <strong>1800 81 9149</strong> if you need any assistance or have
            any questions. We are ready to serve you.&nbsp;
          </p>
        </div>
      ),
    },
    {
      header: "ARBM Internet Banking Schedule Maintenance – 8th July 2023",
      body: (
        <div className="accordion-body">
          <p>Hi Rizers,</p>

          <p>
            Please be informed that the following services will be temporarily
            unavailable due to scheduled system maintenance:
          </p>

          <p>
            <u>
              <strong>Maintenance Details:</strong>
            </u>
          </p>

          <p>
            <strong>Date: 8th July 2023 (Saturday)</strong>
          </p>

          <p>
            <strong>Time: 00.30 a.m. &ndash; 06.00 a.m.</strong>
          </p>

          <p>
            <strong>
              Remarks: During this period all below applications inaccessible.
            </strong>
          </p>

          <p>
            <strong>Affected Services:</strong>
          </p>

          <ol>
            <li>
              <b>Rize - Digital Bank App</b>
            </li>
          </ol>

          <p>
            We apologize for causing inconvenience to you. Please contact our{" "}
            <strong>Customer Care </strong>at <strong>1800 81 9149</strong> if
            you need any assistance or have any questions. We are ready to serve
            you.&nbsp;
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption - 25th Nov 2023",
      body: (
        <div className="accordion-body">
          <p>
            Hi Rizers,
            <br />
            <br />
            Please be informed that the following services will be temporarily
            unavailable due to a scheduled system maintenance:
            <br />
            <br />
            <b>Details:</b>
            <br />
            Date: 25 Nov 2023 (Saturday)
            <br />
            Time: 12:30 a.m. &ndash; 01:00 p.m. (12 hours 30 minutes)
            <br />
            <br />
            We apologize for any inconvenience this may cause.
            <br />
            Please contact our Customer Support team for assistance.
          </p>

          <ul>
            <li>
              <strong>1800 81 9149 </strong>(Local toll-free)
            </li>
            <li>
              <strong>+6016 299 6610 </strong>(Local &amp; overseas)
            </li>
          </ul>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption - 3,7,9 & 10th Dec 2023 ",
      body: (
        <div className="accordion-body">
          <p>
            Hi Rizers,
            <br />
            <br />
            Please be informed that the following services will be temporarily
            unavailable due to a scheduled system maintenance:
            <br />
            <br />
            <b>Details:</b>
            <br />
            Date: 3 Dec 2023 (Sunday)
            <br />
            Time: 02:00 a.m. &ndash; 06:30 a.m. (4 hours 30 minutes)
            <br />
            <br />
            Date: 7 Dec 2023 (Thursday)
            <br />
            Time: 02:00 a.m. &ndash; 05:00 a.m. (3 hours 00 minutes)
            <br />
            <br />
            Date: 9 Dec 2023 (Saturday)
            <br />
            Time: 12:30 a.m. &ndash; 12:30 p.m. (12 hours 00 minutes)
            <br />
            <br />
            Date: 10 Dec 2023 (Sunday)
            <br />
            Time: 12:30 a.m. &ndash; 08:30 a.m. (8 hours 00 minutes)
            <br />
            <br />
            We apologize for any inconvenience this may cause.
            <br />
            Please contact our Customer Support team for assistance.
          </p>

          <ul>
            <li>
              <strong>1800 81 9149&nbsp;</strong>(Local toll-free)
            </li>
            <li>
              <strong>+6016 299 6610&nbsp;</strong>(Local &amp; overseas)
            </li>
          </ul>
        </div>
      ),
    },
    {
      header:
        "Intermittent Service Interruption - 1st Dec 2023 [UPDATE: Services have resumed]",
      body: (
        <div>
          <p>UPDATE: The Rize app services have resumed.</p>

          <p>
            Hi Rizers, the Rize app is experiencing intermittent service
            interruption. We are sorry for the inconvenience.
          </p>
        </div>
      ),
    },
    {
      header:
        "Intermittent service interruption for Android users - 2 Dec 2023",
      body: (
        <div className="accordion-body">
          <p>Hi Rizers,</p>

          <p>
            The Rize app is experiencing intermittent service interruption for
            Android users. We are sorry for the inconvenience caused. We
            appreciate your patience and understanding.
          </p>

          <p>
            If you require assistance during this time, please contact our
            Customer Support Team at:
          </p>

          <ul>
            <li>1800 819 149 (Local toll-free)</li>
            <li>+6016 299 6610 (Local &amp; overseas)</li>
            <li>or email rize-cs@alrajhibank.com.my</li>
          </ul>
        </div>
      ),
    },
    {
      header: "UPDATE",
      body: (
        <div className="accordion-body">
          <p>
            Please be informed that we will normalise a vast majority of
            customer accounts and transactions today. We are doing our best to
            resolve issues with the remaining accounts and hope to complete all
            by 05/12/2023.
          </p>

          <p>
            We sincerely apologize for the disruption this may have caused you
            and thank you for your patience during this time.
          </p>
        </div>
      ),
    },
    {
      header: "Temporary Service Disruption - 7 Dec 2023 ",
      body: (
        <div className="accordion-body">
          <p>Published date: 6 December 2023</p>

          <p>Hi Rizers,</p>

          <p>
            Please be informed that the Rize app is scheduled to undergo
            necessary system maintenance on{" "}
            <b>Thursday, 7 December 2023, from 2.00 am to 6.30 am.</b> During
            this time, incoming and outgoing transactions will not be available.
            We apologize for any inconvenience this may cause, but don&rsquo;t
            worry, we&rsquo;ll be back soon!
          </p>

          <p>
            For assistance, please get in touch with our Customer Support team
            at 1800 81 9149&nbsp;(Local toll-free) or +6016 299 6610&nbsp;(Local
            &amp; overseas).
          </p>
        </div>
      ),
    },
  ],
  jan23: [
    {
      header: " Revision to the Specific Terms and Conditions",
      body: (
        <div className="accordion-body">
          <p>
            10<sup>th</sup>&nbsp;January 2023
          </p>

          <p>&nbsp;</p>

          <p>
            <b>Revision to the Specific Terms and Conditions</b>
          </p>

          <hr />
          <p>Dear Valued Customers,</p>

          <p>&nbsp;</p>

          <p>
            Please be informed that the Bank&rsquo;s Specific Terms and
            Conditions (&ldquo;Specific T&amp;C&rdquo;) has been revised to
            include definitions of security codes issued by the Bank and
            security codes generated by other security devices, mobile
            application or other secured method authorized by the Bank. The
            latest Specific T&amp;C is now available in our website. The
            revised&nbsp;
            <a
              href="https://www.rize.com.my/index.php/download_file/view/c204863c-fb9a-4819-b76a-dc4d06b60420"
              style={{ color: "blue" }}
            >
              Specific T&amp;C
            </a>
            &nbsp;will take effect on 1<sup>st</sup>&nbsp;February 2023 for our
            existing customers.
          </p>

          <p>&nbsp;</p>

          <p>
            Please&nbsp;
            <a
              href="https://www.rize.com.my/index.php/download_file/view/1fc81b15-4532-4236-bee8-79bfaf0c6631"
              style={{ color: "blue" }}
            >
              click here
            </a>
            &nbsp;for the details of the updates.
          </p>

          <p>&nbsp;</p>

          <p>Al Rajhi Banking &amp; Investment Corporation (Malaysia) Bhd</p>

          <p>["Registration Number 200501036909 (719057-X)"]</p>

          <p>&nbsp;</p>
        </div>
      ),
    },
  ],
  june23: [
    {
      header: "Revision to the Specific Terms and Conditions",
      body: (
        <div className="accordion-body">
          <p>
            20<sup>th</sup>&nbsp;June 2023
          </p>

          <p>
            <br />
            <b>Revision to the Specific Terms and Conditions</b>
          </p>

          <hr />
          <p>
            Dear Valued Customers,
            <br />
            &nbsp;
          </p>

          <p>
            Effective 20 June 2023, the updated Specific Terms and Conditions
            applicable to Unit Trust (Retail Customers) will be applicable.
            Please refer to&nbsp;for the&nbsp;
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/Specific_Terms_and_Conditions_V.20Jun2023.pdf">
              <font color="blue">Specific T&amp;C</font>
            </a>
            &nbsp;for the updated Specific Terms and Conditions. The revised
            terms and conditions will take effect on 12<sup>th</sup>&nbsp;July
            2023 for our existing customers.&nbsp;
            <br />
            &nbsp;
          </p>

          <p>Al Rajhi Banking &amp; Investment Corporation (Malaysia) Bhd</p>

          <p>[Registration Number 200501036909 (719057-X)]</p>
        </div>
      ),
    },
  ],
  jan24: [
    {
      header: "Rize (2) Deposit Campaign 2024",
      body: (
        <div className="accordion-body">
          <p>
            1 January 2024
            <br />
            <br />
            RIZE Deposit Campaign 2024
          </p>

          <p>
            ------------------------------
            <wbr />
            -----------
            <br />
            Dear Valued Customers,
            <br />
            <br />
            1. CAMPAIGN PERIOD
            <br />
            This Campaign is valid from 1 January 2024 until 31 March 2024, both
            dates inclusive (&ldquo;Campaign Period&rdquo;).
            <br />
            <br />
            2. ELIGIBILITY
            <br />
            This Campaign is open to all active Commodity Murabahah Savings
            Account-i (&ldquo;CMSA&rdquo;) account holders opened via Rize
            application, including those opened during the Campaign Period:
          </p>

          <p>EXCEPT for the following categories:</p>

          <p>a)&nbsp;Individuals whose CMSA account(s) have been suspended;</p>

          <p>
            b)&nbsp;Existing Rize customers whose banking facilities with Al
            Rajhi Banking &amp; Investment Corporation (Malaysia) Berhad
            (&ldquo;ARB&quot;) is in arrears or whose accounts are delinquent,
            involved in fraudulent transactions, suspected
          </p>

          <p>
            under Anti-Money Laundering related matters and/or any other
            unlawful activities which warrant ARB to take appropriate actions;
            or
          </p>

          <p>c)&nbsp;Non-individuals or corporate customers.</p>

          <p>
            <br />
            (henceforth referred to as &ldquo;<b>Eligible Customer(s)</b>
            &rdquo;)
            <br />
            <br />
            Please
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/RIZE_REVISED_DEPOSIT_CAMPAIGN_2024_TnC.pdf">
              <font color="blue">click here</font>
            </a>
            for the details of the updates.
          </p>
        </div>
      ),
    },
  ],
  apr24: [
    {
      header:
        "Revision to the Personal Financing-i Terms and Conditions, and Declaration and Authorisation",
      body: (
        <div className="accordion-body">
          <p>
            5<sup>th</sup>&nbsp;March 2024
            <br />
            <br />
            &nbsp;
          </p>

          <p>
            <b>
              Revision to the Personal Financing-<i>i&nbsp;</i>Terms and
              Conditions, and Declaration and Authorisation&nbsp;
            </b>
          </p>

          <hr align="center" noshade="noshade" size="1" width="100%" />
          <p>
            Dear Valued Customers,
            <br />
            <br />
            <br />
            Please be informed that the Bank&rsquo;s Personal Financing-<i>i</i>
            &nbsp;Terms and Condition, and Declaration and Authorisation has
            been revised. The latest Personal Financing-<i>i</i>&nbsp;Terms and
            Condition, and Declaration and Authorisation are now available in
            our website. The revised&nbsp;Bank&rsquo;s
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/personal.pdf">
              <font color="blue">
                Personal Financing-i&nbsp;Terms and Conditions
              </font>
            </a>
            , and{" "}
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/PF-i_declaration_5March2024.pdf">
              <font color="blue">
                Personal Financing-i&nbsp;Declaration and Authorisation
              </font>
            </a>{" "}
            will take effect on 27<sup>th</sup>&nbsp;March 2024 for our existing
            customers.
          </p>

          <p>
            <br />
            <br />
            Al Rajhi Banking &amp; Investment Corporation (Malaysia) Bhd
          </p>

          <p>[Registration Number 200501036909 (719057-X)</p>
        </div>
      ),
    },
  ],
  may24: [
    {
      header:
        "Revision to the Rize Personal Financing-i 2024 Promotion Terms & Conditions",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/pfi_tnc_amended_notice.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
  ],
  jul24: [
    {
      header: "Revision to the Specific Terms and Conditions",
      body: (
        <div className="accordion-body">
          <p>
            9<sup>th</sup>&nbsp;July 2024
          </p>

          <p>
            <br />
            <b>Revision to the Specific Terms and Conditions</b>
          </p>

          <hr />
          <p>
            Dear Valued Customers,
            <br />
            &nbsp;
          </p>

          <p>
            Please be informed that the Bank&#39;s Specific Terms and Conditions
            (&quot;Specific T&amp;C&quot;) have been revised. The revisions are
            limited to:
            <br />
            &nbsp;
          </p>

          <ol>
            <li>
              <strong>Section I: Liabilities (D) </strong>Specific Terms &amp;
              Conditions applicable to Debit / ATM card, and
              <br />
              &nbsp;
            </li>
            <li>
              <strong>Section II: Wealth Management (B) </strong>Specific Terms
              and Conditions applicable to Structured Product-<em>i</em>
            </li>
          </ol>

          <p>
            <br />
            The latest
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/9_specific_tnc_%205th_august_2024.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">
                <strong>Specific T&amp;C</strong>
              </font>
            </a>
            is now available on our website. The revised Specific T&amp;C will
            take effect for our existing customers on 5th August 2024.
          </p>

          <p>
            <br />
            Please
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/stc_card_table_of_changes_combined_090724.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">
                <strong>click here</strong>
              </font>
            </a>
            for the details of the updates.
          </p>

          <p>
            <br />
            The previous version of Specific T&amp;C, kindly
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/Specific_Terms_and_Conditions_V.20Jun2023.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">
                <strong>click here</strong>
              </font>
            </a>
          </p>

          <p>&nbsp;</p>

          <p>Al Rajhi Banking &amp; Investment Corporation (Malaysia) Bhd</p>

          <p>[Registration Number 200501036909 (719057-X)</p>
        </div>
      ),
    },
  ],
  campaigns: [
    {
      header: "Rize Deposit Campaign 2024 (2) (Extension)",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/RIZE_REVISED_DEPOSIT_CAMPAIGN_2024_TnC.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "Rize Personal Financing-i 2024 Promotion",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/pfi_tnc_amended.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "Rize Deposit Campaign 2024 (2)",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/RIZE_REVISED_DEPOSIT_CAMPAIGN_2024_TnC%20(2)_2.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "Rize Ultra Fan Sharp Shooter Challenge",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/Rize_Ultra_Fan_SharpShooter_Challenge_TC.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "RIZE CEO Challenge Campaign 2023",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/rize_ceo.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "Liga Malaysia Campaign 2023",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/mfl.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Download</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "rize Fahrenheit Activation",
      body: (
        <div className="accordion-body">
          <p>
            <a
              href="https://www.rize.com.my/index.php/download_file/view/67956a8f-5399-4592-a1ea-0e5200f0bc25"
              target="_blank"
              rel="noreferrer"
            >
              <font color="blue">Highlight</font>
            </a>
          </p>
        </div>
      ),
    },
  ],
  media: [
    {
      header:
        "alrajhi bank Malaysia's Rize Customer Zooms Away in BYD Dolphin EV",
      body: (
        <div>
          <a
            href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/Media_Alert_Rizer_wins_RM125480_BYD_DOLPHIN_EV_Car_in_Electrify_Your_Dreams_Campaign.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <font color="blue">Download</font>
          </a>
        </div>
      ),
    },
    {
      header: "Rize’s Do Less, Get More Winners Celebrate Samsung Prizes",
      body: (
        <div>
          <a
            href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/media_alert_samsung_byd.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <font color="blue">Download</font>
          </a>
        </div>
      ),
    },
    {
      header:
        "Rize Launches One of Market’s Lowest Personal Financing-i Rates - 3.79% p.a.*",
      body: (
        <div>
          <a
            href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/media-pfi.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <font color="blue">Download</font>
          </a>
        </div>
      ),
    },
    {
      header: "rize Deposit Campaign 2023",
      body: (
        <div>
          <a
            href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/MediaAlertRizeDepositCampaign2023.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <font color="blue">Download</font>
          </a>
        </div>
      ),
    },
    {
      header: "rize Digital Bank Partner for Liga Malaysia 2023",
      body: (
        <div>
          <a
            href="https://www.rize.com.my/index.php/download_file/view/3570cb76-ed87-4e26-8e16-467f8636c038"
            target="_blank"
            rel="noreferrer"
          >
            <font color="blue">Download</font>
          </a>
        </div>
      ),
    },
    {
      header: "rize Media Launch 2022",
      body: (
        <div>
          <a
            href="https://www.rize.com.my/index.php/download_file/view/7aec3693-6d20-476e-b41e-bb71d1af4093"
            target="_blank"
            rel="noreferrer"
          >
            <font color="blue">Download</font>
          </a>
        </div>
      ),
    },
  ],

  docs: [
    {
      header: "Declaration and Authorisation",
      body: (
        <div>
          <p>
            <a href="https://www.rize.com.my/index.php/download_file/view/c63e0806-eb00-4136-bae9-ceaa766b4814">
              <font color="blue">
                Deposit Account-𝘪 and Debit Card-𝘪 Declaration and Authorisation
              </font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/PF-i_declaration_5March2024.pdf">
              <font color="blue">
                Personal Financing-𝘪 Declaration and Authorisation
              </font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "PIDM DIS Brochure",
      body: (
        <div>
          <p>
            <a href="https://www.pidm.gov.my/pidm2022/media/downloads/Deposit-Insurance-System-Brochures.pdf">
              <font color="blue">PIDM DIS Brochure (English)</font>
            </a>
            <br />
            <br />
            <a href="https://www.pidm.gov.my/pidm2022/media/downloads/Sistem-Insurans-Deposit-Risalah.pdf">
              <font color="blue">PIDM DIS Brochure (Bahasa Malaysia)</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "Personal Data Protection",
      body: (
        <div>
          <p>
            <a href="https://www.alrajhibank.com.my/images/page_pdfs/PERSONAL_DATA_PROTECTION_NOTICE_2024.pdf">
              <font color="blue">Personal Data Protection</font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "Product Disclosure Sheet",
      body: (
        <div>
          <p>
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/commodity.pdf">
              <font color="blue">
                Commodity Murabahah Savings Account-𝘪 Product Disclosure Sheet
              </font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/pds_debit2922024.pdf">
              <font color="blue">Debit Card-𝘪 Product Disclosure Sheet</font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/personal.pdf">
              <font color="blue">
                Personal Financing-𝘪 Product Disclosure Sheet
              </font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "Terms and Conditions",
      body: (
        <div>
          <p>
            <a href="https://www.rize.com.my/index.php/download_file/view/b12ae8e5-c05c-49ae-a9bd-bdce11abdc67">
              <font color="blue">General Terms and Conditions</font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/9_specific_tnc_%205th_august_2024.pdf">
              <font color="blue">Specific Terms and Conditions</font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/index.php/download_file/view/891886fb-bb0e-40b7-81fd-fab1755dc07a">
              <font color="blue">
                National Addressing Database (NAD) Terms and Conditions
              </font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/index.php/download_file/view/4e74bbb7-5c69-4921-8a07-e00da608f2f5">
              <font color="blue">DuitNow Transfer Terms and Conditions</font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/index.php/download_file/view/eaf1c8c1-c82d-4b13-8a25-f31a2ffd91e8">
              <font color="blue">DuitNow QR Terms and Conditions</font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/duitnow_online_banking_tnc.pdf">
              <font color="blue">
                DuitNow Online Banking/Wallets Terms and Conditions
              </font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/index.php/download_file/view/a34669ea-a5a4-4a45-8514-8d46d934cd42">
              <font color="blue">
                Internet and Mobile Banking Terms and Conditions
              </font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/application/themes/RizeTheme/assets/pdf/PF-i_Tnc_5March2024.pdf">
              <font color="blue">
                Personal Financing-𝘪 Terms and Conditions
              </font>
            </a>
          </p>
        </div>
      ),
    },
    {
      header: "General Terms and Conditions",
      body: (
        <div>
          <p>
            <a href="https://www.rize.com.my/index.php/download_file/view/17fa598f-aa48-4a26-9fa1-8d88b548e811">
              <font color="blue">Client Charter</font>
            </a>
            <br />
            <br />
            <a href="https://www.rize.com.my/index.php/download_file/view/da99e900-c43d-4abe-a19d-980922d47587">
              <font color="blue">Treating Customer Fairly</font>
            </a>
          </p>
        </div>
      ),
    },
  ],
};
